import { tablePersistenceStore } from '@terra/ui-design-system';
import { useLayoutStore } from './layoutStore';
import { useProjectStore } from './projectStore';
import { useChatTabsStore } from './chatTabsStore';
import { useDomainTreeStore } from './domainTreeStore';
import { useWebSocketStore } from './websocket-store';
import { useComparerStore } from './comparer-store';
import { useTerminalStore } from './terminalStore';
import { useReplayStore } from './replay-store';
import { useReplaySessionStore } from './replaySessionStore';
import { useChatInstancesStore } from './chatInstancesStore';
import {
  migrateBottomPanelStateFromLayoutStore,
  useBottomPanelStore,
} from './bottomPanelStore';
import {
  pruneOrphanTabScopedEntries,
  tabScopedStore,
} from './tab/tabScopedStore';
import { useExecutionsStore } from './executionsStore';
import { useExternalNetworkGraphViewModeStore } from './surfaceGraphViewModeStore';
import { useTargetVisitsStore } from './targetVisitsStore';
import { validateProjectTenantAlignment } from '../hooks/useValidateProjectTenant';

export async function rehydrateTenantScopedStores(): Promise<void> {
  await Promise.all([
    useLayoutStore.persist.rehydrate(),
    useProjectStore.persist.rehydrate(),
    useChatTabsStore.persist.rehydrate(),
    useDomainTreeStore.persist.rehydrate(),
    useWebSocketStore.persist.rehydrate(),
    useComparerStore.persist.rehydrate(),
    useTerminalStore.persist.rehydrate(),
    useReplayStore.persist.rehydrate(),
    useReplaySessionStore.persist.rehydrate(),
    useBottomPanelStore.persist.rehydrate(),
    tabScopedStore.persist.rehydrate(),
    tablePersistenceStore.persist.rehydrate(),
    useExecutionsStore.persist.rehydrate(),
    useExternalNetworkGraphViewModeStore.persist.rehydrate(),
    useTargetVisitsStore.persist.rehydrate(),
  ]);

  migrateBottomPanelStateFromLayoutStore();
  useBottomPanelStore.getState().close();
  useChatInstancesStore.getState().rehydrateQueuedMessages();
  validateProjectTenantAlignment();

  const layoutState = useLayoutStore.getState();
  const savedTabIds = Object.values(layoutState.savedPinnedTabs).flatMap(
    (workspace) => workspace.tabs.map((tab) => tab.id),
  );
  const validTabIds = new Set([
    ...layoutState.mainContentTabs.map((tab) => tab.id),
    ...savedTabIds,
  ]);

  pruneOrphanTabScopedEntries(validTabIds);
}
